import { __extends } from "tslib";
import * as React from "react";
export var RadioButtonContext = /*#__PURE__*/React.createContext(null);
/**
 * Radio button group allows to control a group of radio buttons.
 *
 * ## Usage
 * ```js
 * import * as React from 'react';
 * import { View } from 'react-native';
 * import { RadioButton, Text } from 'pnmac-universal-components';
 *
 * export default class MyComponent extends React.Component {
 *   state = {
 *     value: 'first',
 *   };
 *
 *   render() {
 *     return(
 *       <RadioButton.Group
 *         onValueChange={value => this.setState({ value })}
 *         value={this.state.value}
 *       >
 *         <View>
 *           <Text>First</Text>
 *           <RadioButton value="first" />
 *         </View>
 *         <View>
 *           <Text>Second</Text>
 *           <RadioButton value="second" />
 *         </View>
 *       </RadioButton.Group>
 *     )
 *   }
 * }
 *```
 */
var RadioButtonGroup = /** @class */function (_super) {
  __extends(RadioButtonGroup, _super);
  function RadioButtonGroup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  RadioButtonGroup.prototype.render = function () {
    var _a = this.props,
      value = _a.value,
      onValueChange = _a.onValueChange,
      children = _a.children;
    return /*#__PURE__*/React.createElement(RadioButtonContext.Provider, {
      value: {
        value: value,
        onValueChange: onValueChange
      }
    }, children);
  };
  RadioButtonGroup.displayName = "RadioButton.Group";
  return RadioButtonGroup;
}(React.Component);
export default RadioButtonGroup;